/**************************************************
 * Nombre:       Seccione_Nosotros
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Testimonios from "./Componentes/SubComponentes/Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import Nosotros_Portada from "./Componentes/Nosotros_Portada";
import Nosotros_Logos from "./Componentes/Nosotros_Logos";
import Nosotros_Aportes from "./Componentes/Nosotros_Aportes";

const Seccione_Nosotros = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Nosotros_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Nosotros_Logos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Nosotros_Aportes/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>

        </Grid>
    )

}
export default Seccione_Nosotros